// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
// Google Analytics retiré de l'application : il déposait des cookies sans
// consentement (non conforme CNIL) sur des pages contenant des données d'acheteurs.

const firebaseConfig = {
  apiKey: "AIzaSyDwDBwH1f7Y7hs0HcyM_bPmW8FB5wS2D5w",
  // Connexion Google : en production, l'écran Google affiche « app.tombo.live »
  // et la redirection reste sur le même domaine (indispensable pour l'app installée sur iPhone).
  authDomain: typeof window !== "undefined" && window.location.hostname === "app.tombo.live"
    ? "app.tombo.live"
    : "tombolive-prod.firebaseapp.com",
  projectId: "tombolive-prod",
  storageBucket: "tombolive-prod.firebasestorage.app",
  messagingSenderId: "444661145842",
  appId: "1:444661145842:web:318469e6b03db1a994306b",
  measurementId: "G-RE40XH97TY",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Persistence locale multi-onglets
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export default app;
